import { LitElement, html } from '@hh/global.js'

class ProductCard extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleLinkClick()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleLinkClick() {
    const link = this.querySelector('[data-product-card-link]')

    link?.addEventListener('click', (e) => {
      if (!e.target.closest('a')) return

      const linkHasPageReference = e.target.closest(`[data-page]`)
      if (!linkHasPageReference) return true

      e.preventDefault()

      const updatedURL = new URL(window.location.href)

      if (linkHasPageReference.hasAttribute('id')) {
        updatedURL.hash = linkHasPageReference.getAttribute('id')
      }

      updatedURL.searchParams.set('page', linkHasPageReference.dataset.page)

      history.pushState({}, '', updatedURL.toString())

      window.location.href = linkHasPageReference.getAttribute('href')
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-card', ProductCard)
